import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  Wallet,
  ShieldCheck,
  Store,
  ReceiptText,
  ArrowUpRight,
  Building2,
} from "lucide-react";

import Footer from "../components/Footer";

import "../styles/home.css";

import logo from "../assets/logo.png";

const Home = () => {

  const navigate =
    useNavigate();

  const [isAuthenticated,
    setIsAuthenticated,
  ] = useState(false);

  useEffect(() => {

    const authStatus =
      sessionStorage.getItem(
        "authenticated"
      );

    if (
      authStatus === "true"
    ) {

      setIsAuthenticated(
        true
      );

    } else {

      navigate("/login");

    }

  }, [navigate]);

  if (!isAuthenticated)
    return null;

  /* =========================================
      PLATFORM LINKS
  ========================================= */

  const platformLinks = [

    {
      title:
        "Receivables",

      subtitle:
        "Client balances & invoices",

      icon: Wallet,

      url:
        "https://receivables.rcsgy.com",

      position:
        "top-left",
    },

    {
      title:
        "Admin App",

      subtitle:
        "Financial operations",

      icon: ShieldCheck,

      url:
        "https://admin.rcsgy.com",

      position:
        "top-right",
    },

    {
      title:
        "POS System",

      subtitle:
        "Retail & checkout management",

      icon: Store,

      url:
        "https://pos.rcsgy.com",

      position:
        "bottom-left",
    },

    {
      title:
        "Invoice Generator",

      subtitle:
        "Generate branded invoices",

      icon: ReceiptText,

      url:
        "https://invoice.rcsgy.com",

      position:
        "bottom-right",
    },

  ];

  return (

    <div className="rcs-home-modern-page">

      {/* BACKGROUND GLOWS */}

      <div className="rcs-home-modern-glow-one" />

      <div className="rcs-home-modern-glow-two" />

      {/* HERO */}

      <div className="rcs-home-modern-hero">

        {/* LEFT */}

        <div className="rcs-home-modern-left">

          <div className="rcs-home-modern-badge">

            <Building2 size={15} />

            RCS MANAGEMENT CENTER

          </div>

          <h1>

            One Ecosystem.
            <br />

            One Business.
            <br />

            <span>
              Total Control.
            </span>

          </h1>

<p>

  Unified access to
  all financial,
  operational and management
  platforms owned by RCS.

  <br />
  <br />

  Kindly contact admin for login credentials to each platform.

  <br />
  <br />

  <span className="crafted-line">

    Crafted and perfected single-handedly by
    Mr. Rupesh Coysilram,
    Owner & Founder of RCS.

  </span>

</p>

        </div>

        {/* CENTER */}

        <div className="rcs-home-modern-center">

          {/* CENTER LOGO */}

          <div className="rcs-home-modern-logo-ring">

            <div className="rcs-home-modern-logo-core">

              <img
                src={logo}
                alt="RCS Logo"
              />

            </div>

          </div>

          {/* FLOATING APPS */}

          {platformLinks.map(
            (item, index) => {

              const Icon =
                item.icon;

              return (

                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`rcs-home-modern-platform-card ${item.position}`}
                >

                  <div className="rcs-home-modern-platform-icon">

                    <Icon
                      size={22}
                    />

                  </div>

                  <div className="rcs-home-modern-platform-content">

                    <h3>
                      {item.title}
                    </h3>

                    <p>
                      {
                        item.subtitle
                      }
                    </p>

                  </div>

                  <ArrowUpRight
                    size={18}
                    className="rcs-home-modern-platform-arrow"
                  />

                </a>
              );
            }
          )}

          {/* ORBIT */}

          <div className="rcs-home-modern-orbit" />

        </div>

      </div>

      <Footer />

    </div>
  );
};

export default Home;